import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { createAction, props } from '@ngrx/store'

import { RolePermissions } from './role-permissions'

export const rolePermissionsActions = {
  // standard resource actions
  fetchOneById: createAction(
    '[RolePermissionss] Fetch by id',
    props<{ id: number; params?: RequestQueryBuilder }>()
  ),
  fetchMany: createAction(
    '[RolePermissionss] Fetch many',
    props<{ params?: RequestQueryBuilder }>()
  ),
  createOne: createAction(
    '[RolePermissionss] Create one',
    props<{ entity: Partial<RolePermissions> }>()
  ),
  createMany: createAction(
    '[RolePermissionss] Create many',
    props<{ entities: Partial<RolePermissions>[] }>()
  ),
  updateOneById: createAction(
    '[RolePermissionss] Update one by id',
    props<{ id: number; params: Partial<RolePermissions> }>()
  ),
  upsertOne: createAction(
    '[RolePermissionss] Upsert one',
    props<{ entity: RolePermissions }>()
  ),
  upsertMany: createAction(
    '[RolePermissionss] Upsert many',
    props<{ entities: RolePermissions[] }>()
  ),
  deleteOne: createAction(
    '[RolePermissionss] Delete one',
    props<{ id: number }>()
  ),
  deleteMany: createAction(
    '[RolePermissionss] Delete many',
    props<{ ids: string[] }>()
  ),
  removeOne: createAction(
    '[RolePermissionss] Remove one',
    props<{ id: number }>()
  ),
  removeMany: createAction(
    '[RolePermissionss] Remove many',
    props<{ ids: number[] }>()
  ),
  setLoading: createAction(
    '[RolePermissionss] Set loading',
    props<{ isLoading: boolean }>()
  ),
  resetState: createAction('[RolePermissionss] reset state'),
  // special actions
  fetchManyWithBookableSlots: createAction(
    '[RolePermissionss] Fetch many with bookable slots',
    props<{ params?: RequestQueryBuilder }>()
  ),
  fetchManyPublic: createAction(
    '[RolePermissionss] Fetch many public',
    props<{ params?: RequestQueryBuilder }>()
  ),
  sendTestById: createAction(
    '[RolePermissionss] Send test email by id',
    props<{ id: number; toEmail: string }>()
  ),
  // relation actions
  createOneProductLink: createAction(
    '[RolePermissionss] Delete one product link link',
    props<{ rolePermisionsId: number; productId: number }>()
  ),
  deleteOneProductLink: createAction(
    '[RolePermissions] Create one product link',
    props<{ rolePermisionsId: number; productId: number }>()
  ),
  createOneCourseLink: createAction(
    '[RolePermissions] Delete one course link link',
    props<{ rolePermisionsId: number; courseId: number }>()
  ),
  deleteOneCourseLink: createAction(
    '[RolePermissions] Create one course link',
    props<{ rolePermisionsId: number; courseId: number }>()
  ),
  createOneSubscriptionLink: createAction(
    '[RolePermissions] Delete one subscription link link',
    props<{ rolePermisionsId: number; subscriptionId: number }>()
  ),
  deleteOneSubscriptionLink: createAction(
    '[RolePermissions] Create one subscription link',
    props<{ rolePermisionsId: number; subscriptionId: number }>()
  ),
  createOneFineRuleLink: createAction(
    '[RolePermissions] Delete one fineRule link link',
    props<{ rolePermisionsId: number; fineRuleId: number }>()
  ),
  deleteOneFineRuleLink: createAction(
    '[RolePermissions] Create one fineRule link',
    props<{ rolePermisionsId: number; fineRuleId: number }>()
  )
}
